import { FC } from "react";
import { Step } from "../GenerateBookPDFModal";

type Props = {
  steps: Step[];
};

export const GenPDFStepper: FC<Props> = ({ steps }) => {
  return (
    <nav aria-label="Progress" className="my-2">
      <ol role="list" className="space-y-4 md:flex md:space-x-8 md:space-y-0">
        {steps.map((step) => (
          <li key={step.id} className="md:flex-1">
            {step.status === "complete" ? (
              <div className="group flex flex-col border-l-2 border-rust-600 py-2 pl-4 md:border-l-0 md:border-b-2 md:pb-0 md:pl-0 md:pt-2">
                <span className="text-sm font-medium text-rust-600 text-left">
                  {step.id}. {step.name}
                </span>
              </div>
            ) : step.status === "current" ? (
              <div
                aria-current="step"
                className="flex flex-col border-l-2 border-rust-600 py-2 pl-4 md:border-l-0 md:border-b-2 md:pb-0 md:pl-0 md:pt-2"
              >
                <span className="text-sm font-medium text-rust-600 text-left">
                  {step.id}. {step.name}
                </span>
              </div>
            ) : (
              <div className="group flex flex-col border-l-2 border-gray-200 py-2 pl-4 md:border-l-0 md:border-b-2 md:pb-0 md:pl-0 md:pt-2">
                <span className="text-sm font-medium text-gray-500 text-left">
                  {step.id}. {step.name}
                </span>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
